// @flow
import React, { Component } from 'react';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import styles from './LinkContainer.module.scss';

let columnKey = 0;

type Props = {
    active: boolean,
    closeNav: Function,
    linkArray: any[],
    mobile: string,
    picLinkL?: string,
    picLinkS?: string,
};

export default class LinkContainer extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    mapLinks = (link: any) => {
        return (
            <li key={link.text}>
                <Link onClick={this.props.closeNav} route to={link.route}>
                    {link.text}
                </Link>
            </li>
        );
    };

    mapColumn = (columnObject: any) => {
        // inline styling is a workaround for ie 10/11 and edge
        const ulStyle = {
            listStyle: 'none',
        };
        const title = columnObject.headerLink ? (
            <Link className={styles['column-title']} route to={columnObject.headerLink}>
                {columnObject.headerText}
            </Link>
        ) : (
            <div className={styles['column-title']}>{columnObject.headerText}</div>
        );
        return (
            <div key={columnObject.headerText}>
                {title}
                <ul style={ulStyle}>{columnObject.links.map(this.mapLinks)}</ul>
            </div>
        );
    };

    mapLinkObjects = (linkObject: any) => {
        columnKey += 1;
        return (
            <div key={columnKey} className={styles.column}>
                <div className={styles.wrapper}>{linkObject.columnCategories.map(this.mapColumn)}</div>
            </div>
        );
    };

    generateColumns = (linkObjects: any) => {
        return <div className={styles.container}>{linkObjects.map(this.mapLinkObjects)}</div>;
    };

    render() {
        const { active, linkArray, mobile, picLinkL, picLinkS } = this.props;
        const columns = this.generateColumns(linkArray);
        const isTablet = mobile === 'tablet';
        const pictureLink = isTablet ? picLinkS : picLinkL;

        return (
            <div className={`${styles.megaNav} ${active ? '' : 'hidden'}`}>
                <div className={styles.seo}>
                    {columns}
                    {(picLinkL || picLinkS) && <ImageWithFallback src={pictureLink} className={styles.image} />}
                </div>
            </div>
        );
    }
}
